import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  dummyId6: string = 'dummyId6';
  dummyId7: string = 'dummyId7';
  list = [
    { key: "Start Date", value: "21/05/20" },
    { key: "End Date", value: "22/06/20" },
  ];

  createCardForm!: FormGroup;
  enhancedCardForm!: FormGroup;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createCardForm = this.formBuilder.group({
      cardValue: ['dummyValue2']
    });
    this.enhancedCardForm = this.formBuilder.group({
      cardValue: ['dummyValue2']
    });
  }
}